var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "90324d73-5838-4221-982d-f6a287687ffa",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon5",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon5",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/c61d20c8-ce40-4e8f-bd0f-e94515091f3c/db69e5d94bb80ce142942055905bfcbf5c16445a/",
    core: "4.5.1",
    title: "Deco3",
    type: "haiku",
    relpath: "code/deco3/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco3-0c407b0457d72f75": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 14.205,
        "sizeAbsolute.y": 13.798,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:7e8454ab2ad5": {
        "sizeAbsolute.y": 10,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 11,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 7.246,
        "translation.y": 6.746,
        "style.zIndex": 5,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:f828517bf037": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:5faf8540e3cf": {
        fill: "#FFAC39",
        "translation.x": -51,
        "translation.y": -46
      },
      "haiku:34178731f28b": {
        x: 52.4641016,
        y: 46.9641016,
        width: 8,
        height: 8,
        rx: 2,
        "translation.x": 33.046806,
        "translation.y": -21.404156,
        "rotation.z": 0.523599
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco3-0c407b0457d72f75",
      "haiku-title": "Deco3"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "7e8454ab2ad5",
          "haiku-title": "deco3",
          "haiku-source":
            "designs/AnimatorWebsiteIcon5.sketch.contents/slices/deco3.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "f828517bf037",
              "haiku-title": "Page-1",
              id: "c008d085398b"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "5faf8540e3cf",
                  "haiku-title": "Docs-icon",
                  id: "5b5384c8d73b"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "34178731f28b",
                      "haiku-title": "deco3",
                      id: "29aa99b68293"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon5/code/deco3/code.js
// module id = 450
// module chunks = 127651196306611